// extracted by mini-css-extract-plugin
export default {"equipmentLi":"CollapseEquipment_equipmentLi__Bkt+-","columnEquipment":"CollapseEquipment_columnEquipment__1VDtR","blury":"CollapseEquipment_blury__jtbpi"};